import _regeneratorRuntime from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import * as tslib_1 from "tslib";
import _ from 'lodash';
import { GenericErrorResponseCode } from '@tradingblock/types';
import { DateFormats, dateStringOrUndefined, GetTransferInstructionsDocumentMetadataUrl, GetTransferInstructionsDocumentsIdUrl, GetTransferInstructionsDocumentUrl, UploadCashieringDocumentUrl } from '..';
import dayjs from 'dayjs';
var RequestHeaders = {
  headers: {
    Accept: 'application/json'
  }
};
export function SecurityQuestion(api) {
  return {
    fetch: function fetch() {
      return api.authenticated().get("User/GetSecurityChallenge", {}, RequestHeaders);
    },
    verify: function verify(data) {
      return api.authenticated().post("User/VerifySecurityChallenge", data, RequestHeaders);
    }
  };
}

var transformTransfer = function transformTransfer(transferLike) {
  if (!transferLike) return transferLike;
  return Object.assign({}, transferLike, {
    achRelationshipId: transferLike.achRelationship
  });
};

export function Transfers(api) {
  return {
    all: function all(accountId, data) {
      return api.authenticated().get("Cashiering/".concat(accountId, "/Transfers"), data || {}, RequestHeaders).then(function (res) {
        return Object.assign({}, res, {
          payload: res.payload ? res.payload.map(transformTransfer) : []
        });
      });
    },
    get: function get(accountId, transferId) {
      return api.authenticated().get("Cashiering/".concat(accountId, "/Transfers/").concat(transferId), {}, RequestHeaders).then(function (res) {
        return Object.assign({}, res, {
          payload: transformTransfer(res.payload)
        });
      });
    },
    achDeposit: function achDeposit(accountId, data) {
      return api.authenticated().post("Cashiering/".concat(accountId, "/Transfers/Achs/Deposit"), data, RequestHeaders);
    },
    achWithdrawal: function achWithdrawal(accountId, data) {
      return api.authenticated().post("Cashiering/".concat(accountId, "/Transfers/Achs/Withdrawal"), data, RequestHeaders);
    },
    wireWithdrawal: function wireWithdrawal(accountId, data) {
      return api.authenticated().post("Cashiering/".concat(accountId, "/Transfers/Wires/Withdrawal"), data, RequestHeaders);
    },
    checkWithdrawal: function checkWithdrawal(accountId, data) {
      return api.authenticated().post("Cashiering/".concat(accountId, "/Transfers/Checks/Withdrawal"), data, RequestHeaders);
    },
    update: function update(accountId, transferId, payload) {
      return api.authenticated().put("Cashiering/".concat(accountId, "/Transfers/").concat(transferId, "/Update"), payload, RequestHeaders);
    },
    approve: {
      rep: function rep(accountId, transferId, payload) {
        return api.authenticated().post("Cashiering/".concat(accountId, "/Transfers/").concat(transferId, "/ApproveCreateRep"), payload || {}, RequestHeaders);
      },
      firm: function firm(accountId, transferId, payload) {
        return api.authenticated().post("Cashiering/".concat(accountId, "/Transfers/").concat(transferId, "/ApproveCreateFirm"), payload || {}, RequestHeaders);
      }
    },
    reject: function reject(accountId, transferId, note) {
      return api.authenticated().post("Cashiering/".concat(accountId, "/Transfers/").concat(transferId, "/RejectCreate"), {
        note: note
      }, RequestHeaders);
    },
    cancel: function cancel(accountId, transferId, comment) {
      return api.authenticated().put("Cashiering/".concat(accountId, "/Transfers/").concat(transferId, "/Cancel"), {
        comment: comment || 'Cancelled by User'
      }, RequestHeaders);
    }
  };
}
export function ACH(api) {
  return {
    all: function all(accountId) {
      return api.authenticated().get("Cashiering/".concat(accountId, "/AchRelationships"), {}, RequestHeaders);
    },
    get: function get(accountId, achId) {
      return api.authenticated().get("Cashiering/".concat(accountId, "/AchRelationships/").concat(achId), {}, RequestHeaders);
    },
    fetchPlaidLinkToken: function fetchPlaidLinkToken(accountId, redirectUri) {
      return api.authenticated().get("Cashiering/".concat(accountId, "/AchRelationships/PlaidLinkToken"), {
        redirectUri: redirectUri
      }, RequestHeaders);
    },
    create: function create(accountId, data) {
      return api.authenticated().post("Cashiering/".concat(accountId, "/AchRelationships"), data, RequestHeaders);
    },
    approve: function approve(accountId, achId, request) {
      return api.authenticated().post("Cashiering/".concat(accountId, "/AchRelationships/").concat(achId, "/Approve"), request, RequestHeaders);
    },
    approveCreate: function approveCreate(accountId, achId, note, adminNote, mapToRelationshipId) {
      return api.authenticated().post("Cashiering/".concat(accountId, "/AchRelationships/").concat(achId, "/ApproveCreate"), {
        note: note,
        adminNote: adminNote,
        mapToRelationshipId: mapToRelationshipId
      }, RequestHeaders);
    },
    rejectCreate: function rejectCreate(accountId, achId, note) {
      return api.authenticated().post("Cashiering/".concat(accountId, "/AchRelationships/").concat(achId, "/RejectCreate"), {
        note: note
      }, RequestHeaders);
    },
    reIssue: function reIssue(accountId, achId) {
      return api.authenticated().post("Cashiering/".concat(accountId, "/AchRelationships/").concat(achId, "/ReIssue"), {}, RequestHeaders);
    },
    update: function update(accountId, achId, payload) {
      return api.authenticated().put("Cashiering/".concat(accountId, "/AchRelationships/").concat(achId, "/Update"), payload, RequestHeaders);
    },
    cancel: function cancel(accountId, achId, comment) {
      return api.authenticated().put("Cashiering/".concat(accountId, "/AchRelationships/").concat(achId, "/Cancel"), {
        comment: comment || 'Cancelled by User'
      }, RequestHeaders);
    }
  };
}
export function TransferInstructions(api) {
  return {
    all: function all(accountId) {
      return api.authenticated().get("Cashiering/".concat(accountId, "/TransferInstructions/Wires"), {}, RequestHeaders);
    },
    get: function get(accountId, instructionId) {
      return api.authenticated().get("Cashiering/".concat(accountId, "/TransferInstructions/Wires/").concat(instructionId), {}, RequestHeaders);
    },
    details: function details(instructionId) {
      return api.authenticated().get("Cashiering/Search/TransferInstructions/Wires/".concat(instructionId, "/Details"), {}, RequestHeaders);
    },
    create: function create(accountId, data) {
      return api.authenticated().post("Cashiering/".concat(accountId, "/TransferInstructions/Wires"), data, RequestHeaders);
    },
    update: function update(accountId, instructionId, payload) {
      return api.authenticated().put("Cashiering/".concat(accountId, "/TransferInstructions/Wires/").concat(instructionId, "/Update"), payload, RequestHeaders);
    },
    delete: function _delete(accountId, instructionId, comment) {
      return api.authenticated().put("Cashiering/".concat(accountId, "/TransferInstructions/Wires/").concat(instructionId, "/Cancel"), {
        comment: comment
      }, RequestHeaders);
    },
    approveCreate: function approveCreate(accountId, instructionId, payload) {
      return api.authenticated().put("Cashiering/".concat(accountId, "/TransferInstructions/Wires/").concat(instructionId, "/ApproveCreate"), payload, RequestHeaders);
    },
    rejectCreate: function rejectCreate(accountId, instructionId, payload) {
      return api.authenticated().put("Cashiering/".concat(accountId, "/TransferInstructions/Wires/").concat(instructionId, "/RejectCreate"), payload, RequestHeaders);
    },
    cancel: function cancel(accountId, instructionId, payload) {
      return api.authenticated().put("Cashiering/".concat(accountId, "/TransferInstructions/Wires/").concat(instructionId, "/Cancel"), payload, RequestHeaders);
    }
  };
}
export function cashieringSearch(api) {
  var _this = this;

  return {
    search: function search(request) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var startDate, endDate, searchRequest, result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                startDate = _.isNil(request.startDate) ? undefined : dateStringOrUndefined(request.startDate, 'YYYY-MM-DD');
                endDate = _.isNil(request.endDate) ? undefined : dateStringOrUndefined(request.endDate, 'YYYY-MM-DD');
                searchRequest = Object.assign({}, request, {
                  endDate: endDate,
                  startDate: startDate
                });
                _context.next = 5;
                return api.authenticated().get("Cashiering/Search", searchRequest, RequestHeaders);

              case 5:
                result = _context.sent;
                return _context.abrupt("return", result);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  };
}
export function cashieringDetails(api) {
  var _this2 = this;

  return {
    relationshipDetails: function relationshipDetails(id) {
      return tslib_1.__awaiter(_this2, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _ref, responseCode, payload, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return api.authenticated().get("Cashiering/Search/AchRelationships/".concat(id, "/Details"), {}, RequestHeaders);

              case 2:
                _ref = _context2.sent;
                responseCode = _ref.responseCode;
                payload = _ref.payload;
                data = Object.assign({}, payload, {
                  id: id
                });
                return _context2.abrupt("return", {
                  responseCode: responseCode,
                  payload: data
                });

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    },
    transferDetails: function transferDetails(id) {
      return tslib_1.__awaiter(_this2, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _ref2, responseCode, payload, data;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return api.authenticated().get("Cashiering/Search/Transfers/".concat(id, "/Details"), {}, RequestHeaders);

              case 2:
                _ref2 = _context3.sent;
                responseCode = _ref2.responseCode;
                payload = _ref2.payload;
                data = Object.assign({}, payload, {
                  id: id
                });
                return _context3.abrupt("return", {
                  responseCode: responseCode,
                  payload: data
                });

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
  };
}
export function cashieringDocuments(api) {
  var _this3 = this;

  return {
    upload: function upload(file, accountId, recipientBankId, documentType, description) {
      return tslib_1.__awaiter(_this3, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var TakenOn, data;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                TakenOn = dayjs(file.lastModified).utc().format(DateFormats.DateTimeApiFormat);
                data = new FormData();
                data.append('metaData', JSON.stringify({
                  DocumentName: documentType,
                  ImageName: file.name,
                  TakenOn: TakenOn,
                  Description: description
                }));
                data.append('file', file);
                return _context4.abrupt("return", api.authenticated().post(UploadCashieringDocumentUrl(accountId, recipientBankId), data));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    },
    getId: function getId(accountId, instructionId) {
      return tslib_1.__awaiter(_this3, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _ref3, responseCode, payload;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return api.authenticated().get(GetTransferInstructionsDocumentsIdUrl(accountId, instructionId), {}, RequestHeaders);

              case 2:
                _ref3 = _context5.sent;
                responseCode = _ref3.responseCode;
                payload = _ref3.payload;
                return _context5.abrupt("return", {
                  responseCode: responseCode,
                  payload: payload
                });

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
    },
    getDoc: function getDoc(accountId, recipientBankId, id) {
      return tslib_1.__awaiter(_this3, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var url, result, base64, imageBase64;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                url = GetTransferInstructionsDocumentUrl(accountId, recipientBankId, id);
                _context6.prev = 1;
                _context6.next = 4;
                return api.authenticated().getBinary(url, {
                  accountId: accountId,
                  recipientBankId: recipientBankId,
                  id: id
                });

              case 4:
                result = _context6.sent;

                if (!(result.status === 200)) {
                  _context6.next = 9;
                  break;
                }

                base64 = Buffer.from(result.data, 'binary').toString('base64');
                imageBase64 = "data:".concat(result.headers['content-type'], ";base64,").concat(base64);
                return _context6.abrupt("return", imageBase64);

              case 9:
                _context6.next = 15;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](1);
                console.warn('error requesting miscellaneous document', accountId);
                return _context6.abrupt("return", {
                  responseCode: GenericErrorResponseCode,
                  payload: _context6.t0
                });

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[1, 11]]);
      }));
    },
    getDocMetadata: function getDocMetadata(accountId, instructionId, id) {
      return tslib_1.__awaiter(_this3, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var url, result;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                url = GetTransferInstructionsDocumentMetadataUrl(accountId, instructionId, id);
                _context7.prev = 1;
                _context7.next = 4;
                return api.authenticated().get(url, {}, RequestHeaders);

              case 4:
                result = _context7.sent;
                return _context7.abrupt("return", result);

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7["catch"](1);
                console.warn('error requesting miscellaneous document metadata', {
                  accountId: accountId,
                  instructionId: instructionId,
                  id: id
                });
                return _context7.abrupt("return", {
                  responseCode: GenericErrorResponseCode,
                  payload: _context7.t0
                });

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[1, 8]]);
      }));
    }
  };
}
export function cashieringProfile(api) {
  var _this4 = this;

  return {
    get: function get(accountId) {
      return tslib_1.__awaiter(_this4, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var _ref4, responseCode, payload;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return api.authenticated().get("Cashiering/".concat(accountId, "/Profile"), {}, RequestHeaders);

              case 2:
                _ref4 = _context8.sent;
                responseCode = _ref4.responseCode;
                payload = _ref4.payload;
                return _context8.abrupt("return", {
                  responseCode: responseCode,
                  payload: payload
                });

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
    }
  };
}
export function scheduledTransfers(api) {
  var _this5 = this;

  return {
    all: function all(accountId) {
      return tslib_1.__awaiter(_this5, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var _ref5, responseCode, payload;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return api.authenticated().get("Cashiering/".concat(accountId, "/ScheduledTransfers"), {}, RequestHeaders);

              case 2:
                _ref5 = _context9.sent;
                responseCode = _ref5.responseCode;
                payload = _ref5.payload;
                return _context9.abrupt("return", {
                  responseCode: responseCode,
                  payload: payload
                });

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));
    },
    details: function details(accountId, scheduleId) {
      return tslib_1.__awaiter(_this5, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var _ref6, responseCode, payload;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return api.authenticated().get("Cashiering/".concat(accountId, "/ScheduledTransfers/").concat(scheduleId), {}, RequestHeaders);

              case 2:
                _ref6 = _context10.sent;
                responseCode = _ref6.responseCode;
                payload = _ref6.payload;
                return _context10.abrupt("return", {
                  responseCode: responseCode,
                  payload: payload
                });

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));
    },
    achDeposit: function achDeposit(accountId, data) {
      return tslib_1.__awaiter(_this5, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", api.authenticated().post("Cashiering/".concat(accountId, "/ScheduledTransfers/Achs/Deposit"), data, RequestHeaders));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));
    },
    achWithdrawal: function achWithdrawal(accountId, data) {
      return tslib_1.__awaiter(_this5, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", api.authenticated().post("Cashiering/".concat(accountId, "/ScheduledTransfers/Achs/Withdrawal"), data, RequestHeaders));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));
    },
    wireWithdrawal: function wireWithdrawal(accountId, data) {
      return tslib_1.__awaiter(_this5, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", api.authenticated().post("Cashiering/".concat(accountId, "/ScheduledTransfers/Wires/Withdrawal"), data, RequestHeaders));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));
    },
    checkWithdrawal: function checkWithdrawal(accountId, data) {
      return tslib_1.__awaiter(_this5, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", api.authenticated().post("Cashiering/".concat(accountId, "/ScheduledTransfers/Checks/Withdrawal"), data, RequestHeaders));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));
    },
    update: function update(accountId, scheduleId, data) {
      return tslib_1.__awaiter(_this5, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15() {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", api.authenticated().put("Cashiering/".concat(accountId, "/ScheduledTransfers/").concat(scheduleId, "/Update"), data, RequestHeaders));

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));
    },
    cancel: function cancel(accountId, scheduleId) {
      return tslib_1.__awaiter(_this5, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16() {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt("return", api.authenticated().put("Cashiering/".concat(accountId, "/ScheduledTransfers/").concat(scheduleId, "/Cancel"), {}, RequestHeaders));

              case 1:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));
    }
  };
}